var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
import { Component, Vue, Prop } from 'vue-property-decorator';
import { Portfolio as PortfolioModel } from '@/models/Portfolio';
import _ from 'lodash';
import UploadFileDialog from '@/views/Users/Student/Progress/UploadFileDialog';
import ErrorHandler from '@/support/ErrorHandler';
let ProgressCitoResults = class ProgressCitoResults extends Vue {
    constructor() {
        super(...arguments);
        this.portfolioClone = null;
        this.files = [];
        this.deleteResultList = [];
        this.isEditingCitoResults = false;
        this.isUpdatingCitoResults = false;
        this.isUploadingCitoResult = false;
        this.resultFiles = [];
    }
    mounted() {
        this.initialize();
    }
    initialize() {
        this.portfolioClone = _.cloneDeep(this.portfolio);
        this.filterFiles();
    }
    filterFiles() {
        if (!this.portfolioClone || !this.portfolioClone.files) {
            return;
        }
        this.resultFiles = this.portfolioClone.files.filter((file) => {
            return file.collection === 'cito-results';
        });
    }
    fileUploaded() {
        this.$emit('portfolioUpdated');
    }
    resetResults() {
        this.deleteResultList = [];
        this.resultFiles = _.cloneDeep(this.portfolio).files;
        this.filterFiles();
        this.isEditingCitoResults = false;
    }
    deleteResult(deletedFile) {
        this.resultFiles = this.resultFiles.filter((file) => {
            return file.id !== deletedFile.id;
        });
        this.deleteResultList.push(deletedFile);
    }
    updateResults() {
        this.deleteResultList.forEach((file) => {
            new PortfolioModel()
                .deleteFileFromPortfolio(this.portfolio.id, file.id)
                .then(() => {
                this.$emit('portfolioUpdated');
                this.deleteResultList = [];
            })
                .catch((error) => {
                ErrorHandler.network(error);
            });
        });
    }
    get user() {
        return this.$store.state.Auth;
    }
    get dialogOptions() {
        return {
            title: this.$t('progress.dialog.title').toString(),
            text: this.$t('progress.dialog.subtitle', { item: this.$tc('progress.result.title', 2) }).toString(),
            type: 'warning',
            buttons: {
                confirm: {
                    text: this.$t('dialogOptions.button.ok').toString(),
                    action: async () => {
                        await this.updateResults();
                        this.isEditingCitoResults = false;
                    },
                },
                cancel: {
                    text: this.$t('dialogOptions.button.cancel').toString(),
                    action: () => {
                        this.isUpdatingCitoResults = false;
                    },
                },
            },
        };
    }
};
__decorate([
    Prop({ default: {} }),
    __metadata("design:type", typeof (_a = typeof PortfolioModel !== "undefined" && PortfolioModel) === "function" ? _a : Object)
], ProgressCitoResults.prototype, "portfolio", void 0);
ProgressCitoResults = __decorate([
    Component({
        components: {
            'upload-file-dialog': UploadFileDialog,
        },
    })
], ProgressCitoResults);
export default ProgressCitoResults;
